module.exports = __webpack_public_path__ + "img/staging-qr-apk-th-page.e86611bb.png";